import { render, staticRenderFns } from "./CadastroMotivo.vue?vue&type=template&id=4db57e73&"
import script from "./CadastroMotivo.vue?vue&type=script&lang=js&"
export * from "./CadastroMotivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports